import React from 'react';
import { motion } from 'framer-motion';
import './TutorialStep.css';
import DesktopDownloadButtons from '../DownloadButtons/DesktopDownloadButtons';
import IOSDownloadButton from '../DownloadButtons/iOSDownloadButton';

const IPhoneFrame = ({ children, isSmall = true }) => (
  <div className={`iphone-frame ${isSmall ? 'small-iphone' : ''}`}>
    <div className="iphone-notch"></div>
    {children}
    <div className="iphone-home-indicator"></div>
  </div>
);

const TutorialStep = ({ 
  title, 
  description, 
  image, 
  imageDescription,
  videos, 
  annotations = [],
  subSteps = []
}) => {
  const isPhoneVideo = (videoTitle) => {
    return videoTitle.toLowerCase().includes('phone');
  };

  const isDemoSection = title === "See AirMouse in Action";
  const isDesktopInstallSection = title === "Install the Desktop App";
  const isIOSDownloadSection = title === "Download the iOS App";

  const renderMedia = (img, imgDesc, anns) => (
    <div className="image-wrapper">
      <img src={img} alt={imgDesc || title} />
      {anns.map((annotation, index) => (
        <div
          key={index}
          className="annotation-circle"
          style={{
            left: annotation.x,
            top: annotation.y,
          }}
        >
          {annotation.text && (
            <div className="annotation-text">{annotation.text}</div>
          )}
        </div>
      ))}
    </div>
  );

  return (
    <motion.div 
      className="tutorial-step"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      <h3>{title}</h3>
      <p>{description}</p>
      
      <div className="media-container">
        {image && renderMedia(image, imageDescription, annotations)}
        
        {isDesktopInstallSection && <DesktopDownloadButtons />}
        {isIOSDownloadSection && <IOSDownloadButton />}
        
        {videos && (
          <div className="videos-container">
            {videos.map((video, index) => (
              <div key={index} className="video-wrapper">
                <h4>{video.title}</h4>
                {isPhoneVideo(video.title) ? (
                  <div className={`iphone-frame ${isDemoSection ? 'demo-iphone' : ''}`}>
                    <div className="iphone-notch"></div>
                    <video controls>
                      <source src={video.src} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                    <div className="iphone-home-indicator"></div>
                  </div>
                ) : (
                  <video controls>
                    <source src={video.src} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                )}
              </div>
            ))}
          </div>
        )}

        {subSteps && subSteps.length > 0 && (
          <div className="sub-steps">
            {subSteps.map((step, index) => (
              <div key={index} className="sub-step">
                <h4>{step.title}</h4>
                <p>{step.description}</p>
                {step.image && renderMedia(step.image, step.imageDescription, step.annotations)}
                {step.additionalImages && step.additionalImages.map((imgSet, idx) => (
                  <div key={idx} className="image-sequence">
                    {step.title === "Using Device Finder" || imgSet.useIPhoneFrame ? (
                      <>
                        <IPhoneFrame>
                          <img src={imgSet.image} alt="Step 1" />
                        </IPhoneFrame>
                        <span className="arrow">{imgSet.arrow}</span>
                        <IPhoneFrame>
                          <img src={imgSet.middleImage} alt="Step 2" />
                        </IPhoneFrame>
                        <span className="arrow">{imgSet.arrow2}</span>
                        <IPhoneFrame>
                          <img src={imgSet.finalImage} alt="Final Step" />
                        </IPhoneFrame>
                      </>
                    ) : (
                      <>
                        <img src={imgSet.image} alt="Step 1" />
                        <span className="arrow">{imgSet.arrow}</span>
                        {imgSet.middleImage && <img src={imgSet.middleImage} alt="Step 2" />}
                        {imgSet.arrow2 && <span className="arrow">{imgSet.arrow2}</span>}
                        <img src={imgSet.finalImage} alt="Final Step" />
                      </>
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default TutorialStep; 